import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import { useGroupChatContext } from '../../context/groupchatContext';
import ethizologo from "../../assets/images/logo-login.svg";
import { triggerTimerForPincodeScreen } from '../../helpers/utility';


const PinCodeFourDigit = () => {

    const [processing, setProcessing] = useState('');
    const [pinCode, setPinCode] = useState(['', '', '', '']);
    const [status, setStatus] = useState('');

    const groupChatContext = useGroupChatContext();
    const {authData, setIsPinCodeScreenActive, logoutApp} = useMemo(() => ({
        authData: groupChatContext.authData,
        setIsPinCodeScreenActive: groupChatContext.setIsPinCodeScreenActive,
        logoutApp: groupChatContext.logoutApp
    }));

    const focusNextInput = (index) => {
        if(index < 3){
            document.getElementById(`pinInput${index + 1}`).focus();
        }
    }

    const focusPrevInput = (index) => {
        if(index > 0){
            document.getElementById(`pinInput${index - 1}`).focus();
        }
    }

    const handleInputChange = (index, value) => {
        if(value.length === 1 && index < 4) {
            focusNextInput(index)
        }
    
        // Update the pin code state
        const newPinCode = [...pinCode];
        newPinCode[index] = value;
        setPinCode(newPinCode);
    };

    useEffect(()=>{
        const pin = pinCode.join('');
        if(pin?.length === 4){
            verifyPinCode()
        }
    }, [pinCode])

    const verifyPinCode = () => {
        setProcessing('verify_code');
        if(pinCode.join('') == authData.pincode){
            setIsPinCodeScreenActive(false);
            localStorage.setItem('isPinCodeScreenActive', false);
            setProcessing('');
            setPinCode(['', '', '', '']);
            triggerTimerForPincodeScreen();

        }else{
            setStatus('Your PIN is not valid');
            setProcessing('');
            setPinCode(['', '', '', '']);
        }
    }

    const handleOnKeyDown = (index, e) => {
        const pressedKey = e.key;
        switch (pressedKey) {
            case "Backspace":
            case "Delete": {
                e.preventDefault();

                const newPinCode = [...pinCode];
                if(newPinCode[index]) {
                    newPinCode[index] = '';
                    setPinCode(newPinCode);
                }

                focusPrevInput(index);
                break;
            }
            case "ArrowLeft": {
                e.preventDefault();
                focusPrevInput(index);
                break;
            }
            case "ArrowRight": {
                e.preventDefault();
                focusNextInput(index);
                break;
            }
            default: {
                if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                    e.preventDefault();
                }
                else{
                    const newPinCode = [...pinCode];
                    if(newPinCode[index]) {
                        newPinCode[index] = pressedKey;
                        setPinCode(newPinCode);
                    }
                }

                break;
            }
        }
    }

    return (
        <div className="login-bg h-screen flex items-center justify-center z-[1000] relative">
            <div className="login-box rounded-3xl   p-12 w-[650px]">
                    <div className="flex justify-center">
                        <div>
                            <h3 className="text-lg mb-2 font-normal text-black-39"><strong>{authData.name}</strong> Welcome to</h3>
                            <img src={ethizologo} alt="" className="w-[237px]" />
                            <p className="mt-2 text-right text-vColor font-light">V 2.0</p>
                        </div>
                    </div>
                    <div className="flex spacing-y-4 content-center flex-col">
                        <h4 className="text-3xl text-center text-black font-light mb-4">Please Enter 4 Digits PIN</h4>
                        <div className="self-center flex flex-row justify-between mb-4">
                            {pinCode.map((digit, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    id={`pinInput${index}`}
                                    value={digit}
                                    maxLength={1}
                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                    onKeyDown={(e) => handleOnKeyDown(index, e)}
                                    autoComplete="off"
                                    className="w-16 h-16 text-3xl text-center border rounded focus:outline-none focus:border-blue-500"
                                />
                            ))}

                        </div>
                        <div style={{ background: status != '' ? 'rgb(235 16 16 / 10%)' : '' }} className="self-center h-12 flex justify-center items-center w-4/5 text-red-900 sm:text-sm text-xs truncate">
                            <p >{status != '' ? status : " "}</p>
                        </div>

                        <div className="mt-4 self-center flex flex-row justify-between w-4/5">
                            <button
                                className="flex items-center justify-center w-full rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm bg-bgGreen hover:bg-primary-hover"
                                onClick={()=>logoutApp()}
                            >
                                Logout
                            </button>
                        </div>

                    </div>
            </div>
        </div>
    );
};

export default PinCodeFourDigit;
